import React from 'react';

import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Responsive } from '@share/utils';
import { WeeksDetailsWrapper } from '@components';

import './style.scss';

interface IProps extends RouteComponentProps {}

class WeeksDetailsPageComponent extends React.Component<IProps> {
  render(): React.ReactNode {
    return (
      <div className="weeks--details-page">
        <Responsive>
          <WeeksDetailsWrapper />
        </Responsive>
      </div>
    );
  }
}

export const WeeksDetailsPage = connect()(withRouter(WeeksDetailsPageComponent));
